var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Loading"}},[_vm._m(0),_c('div',{staticClass:"loading-tip"},[_vm._v(_vm._s(_vm.tips))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-inner ball-clip-rotate-multiple"},[_c('div'),_c('div')])
}]

export { render, staticRenderFns }